import React, { useState, useEffect,useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { Row, Col,Modal } from 'antd';
import moment from 'moment';
import useWindowSize from 'library/hooks/useWindowSize';
import useMoreDataApi from 'library/hooks/useMoreDataApi';
import {getLocalCurrency} from 'context/currency' ;
import { AuthContext } from 'context/AuthProvider';
import Loader from 'components/Loader/Loader';
import FilterDrawer from './Search/MobileSearchView';
import CategorySearch from './Search/CategorySearch/CategorySearch';
import ListingGrid from './ListingGrid';
import ListingWrapper from './Listing.style';
import { DEFAULT_START_PAGE, LIMIT_SIZE_PAGINATION, MIN_INPUT_SEARCH_LENGTH, TITRE_LISTE_HOTEL } from 'library/helpers/constUtils';
import {useDebounceInput} from 'library/helpers/useDebounceInput';
import { getCurrencyId } from 'library/helpers/fonction';
import {loadState} from 'library/helpers/localStorage' ;
import { SharedDataContext } from 'context/SharedDataProvider';

export default function Listing() {

  let location = useLocation ();
  const {user} = useContext(AuthContext);
  let token = null ; 
  if (user?.roles && user.roles.includes('ROLE_CLIENT')){
    token = user.token ; 
  }
  const { width } = useWindowSize();
  const [currency, setCurrency] = useState(getLocalCurrency());
  const [title, setTitle] = useState(TITRE_LISTE_HOTEL) ;
  const { isFiltreDayUseChecked, filtreDayUseDate, filtreDayUseMomentJournee, 
    currentHotelPage, setCurrentHotelPage } = useContext(SharedDataContext);
  //input search hotel
  const [searchInput, setSearchInput] = useDebounceInput(1000);
  const [isCurrentListFromInputSearch, setIsCurrentListFromInputSearch] = useState(false);
  const [searchInputLoading, setSearchInputLoading] = useState(false);
  const [isActionFromInputSearch, setIsActionFromInputSearch] = useState(false);
  const { scrollPosition, setScrollPosition, saveLastLoadedHotel, setSaveLastLoadedHotel,
    isFromDetail, setIsFromDetail } = useContext(SharedDataContext);
  //var for hotel pagination
  const [diplayLoaderToLoadMoreBtn, setDiplayLoaderToLoadMoreBtn] = useState(false);
  const [isCurrentListFromFilter, setIsCurrentListFromFilter] = useState(false);
  const [diplayLoadMoreBtn, setDiplayLoadMoreBtn] = useState(true);
  let [pageHotelToLoad, setPageHotelToLoad] = useState((currentHotelPage == DEFAULT_START_PAGE) ? DEFAULT_START_PAGE : currentHotelPage);
  const [hotelLoaded, setHotelLoaded] = useState([]);
  
  useEffect(() => {
    window.addEventListener('storage', () => {
      if(getLocalCurrency()){
        setCurrency(getLocalCurrency());
      } 
    });
    
    
    }, []);

  if (loadState("filtre")) localStorage.removeItem("filtre");
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let villeValue = urlParams.get('ville');
  let hebergement = urlParams.get('hebergement');
  let listHebergement = [];
  if (hebergement) listHebergement.push(parseInt(hebergement));
  const customParams = location.state;
  let defaultParamHotel = customParams?.param??null 

  const [loader , setLoader] = useState(false) ;
  const [listHotel , setListHotel] = useState(false) ;

  const addFilterByOffer = urlParams.get('offre') === 'true';
  const [isOffreChecked, setIsOffreChecked] = useState(addFilterByOffer);
  
  const defaultParamsWithDayUse = isFiltreDayUseChecked ? {
    date: filtreDayUseDate ? moment(filtreDayUseDate,'DD-MM-YYYY').format('YYYY-MM-DD') : null,
    momentJournee: filtreDayUseMomentJournee,
    dayUse: isFiltreDayUseChecked
  } : {
    "dateDisponibiliteChambre":   {
      "dateDepart": defaultParamHotel?.date_range?.setStartDate
      ? moment(defaultParamHotel?.date_range?.setStartDate,'DD-MM-YYYY')?.format('YYYY-MM-DD')
      : null,
      "dateEntree": defaultParamHotel?.date_range?.setStartDate
      ? moment(defaultParamHotel?.date_range?.setEndDate,'DD-MM-YYYY')?.format('YYYY-MM-DD')
      : null
    },
  };

  // Initialisation de `paramFiltre`
  const [paramFiltre, setparamFiltre] = useState(() => {
    if(defaultParamHotel){
      return {
        ...defaultParamsWithDayUse,
        "hotelCategories": defaultParamHotel?.property??[],
        "hotelEquipements": defaultParamHotel?.equipement??[],
        "idDevise": getCurrencyId(currency), 
        "prixMin" : defaultParamHotel.price ? defaultParamHotel.price.min : 0,
        "prixMax": defaultParamHotel.price ? defaultParamHotel.price.max : null,
        "idVille" : villeValue??null,
        "nombreChambre" : defaultParamHotel?.room??1,
        "nombreVoyageur" : defaultParamHotel?.guest??1,
        "offrePromo" : isOffreChecked
      };
    }else if(villeValue || hebergement || addFilterByOffer) {
      return {
        "dateDisponibiliteChambre":   null,
        "hotelCategories": listHebergement,
        "hotelEquipements": [],
        "idDevise": getCurrencyId(currency), 
        "prixMin" : 0,
        "prixMax": null,
        "idVille" : villeValue??null,
        "nombreChambre" : defaultParamHotel?.room??1,
        "nombreVoyageur" : defaultParamHotel?.guest??1,
        "offrePromo" : isOffreChecked
      };
    }
    return  null ; //Si aucune condition n'est remplie, retournez null
  });

    const getUrlArray = () => {
    return [
      {
        url: `${process.env.REACT_APP_API_URL}/equipementHebergements`,
        method: 'GET',
        body: {},
      },
      {
        url: `${process.env.REACT_APP_API_URL}/categoriesHotels`,
        method: 'GET',
        body: {},
      },
    ];
  };

  let { data, loading, error, errorMessage } = useMoreDataApi(getUrlArray().map(item=>item.url),
  getUrlArray().map(item=>item.method),
  getUrlArray().map(item=>item.body),
  getUrlArray().map(item=>item.header));

  const isAddSearchHotelByName = () => {
    return searchInput?.length >= MIN_INPUT_SEARCH_LENGTH 
      ||
      (searchInput?.length < MIN_INPUT_SEARCH_LENGTH && isCurrentListFromInputSearch );
  }

  const addsSearchParamToFilterRequest = () => {
    setparamFiltre({
      ...paramFiltre,
      nomHotel: searchInput
    });
  }

  useEffect(() => {
    if(hotelLoaded.length != 0 && scrollPosition>0){
      window.scrollTo(0, scrollPosition)
    }
  }, [hotelLoaded])

  useEffect(() => {
    if (isAddSearchHotelByName()) {
      addsSearchParamToFilterRequest();
      setPageHotelToLoad(0);
      setCurrentHotelPage(0)
      setSearchInputLoading(true);
      setIsActionFromInputSearch(true);
    }
  }, [searchInput])
  

  // reload liste when searchInput updated
  useEffect(() => {
    if (isAddSearchHotelByName() && isActionFromInputSearch) {
      getHotelList()
    }
  }, [isActionFromInputSearch])


  //increments when you click on load more
  const handleLoadMoreHotel = () => {
    const newPage = isCurrentListFromFilter ? 1 : ++pageHotelToLoad
    setCurrentHotelPage(newPage)
    setPageHotelToLoad(newPage);
  }

  // reload getHotelList when pageHotelToLoad value updated
  useEffect(() => {
      //console.log("show page: ", pageHotelToLoad)
      getHotelList();
  }, [pageHotelToLoad]);

  //retrieve hotel by filter && size
  //update hotelLoaded && display loadMoreBtn condition
  const getHotelList = () => {
    setDiplayLoaderToLoadMoreBtn(true);

    if (hotelLoaded <= 0)
      setLoader(true);
    //day use
    let endPointFilter = isFiltreDayUseChecked?'hotels-day-use-filter':'hotels-filter';
    const urlData = defaultParamHotel || villeValue || hebergement || addFilterByOffer || isAddSearchHotelByName
    ? 
    {
      url: `${process.env.REACT_APP_API_URL}/${endPointFilter}`,
      method: 'POST',
      body: JSON.stringify({
        ...paramFiltre,
      }),
      header:(token ?  {
            'Content-type': 'application/json',
            "Authorization": `Bearer ${user?.token}`
          } : {'Content-type': 'application/json'} )
    }
    : {
        url: `${process.env.REACT_APP_API_URL}/hotels-pagination`,
        method: 'GET',
        body: {},
        header:(token ?  {
              'Content-type': 'application/json',
              "Authorization": `Bearer ${user?.token}`
            } : {'Content-type': 'application/json'} )
      };

    const options = {
      method: urlData.method,
      headers: urlData.header
    }

    if (urlData.method === 'POST') {
      options.body = urlData.body;
    }

    const inputSearchHotelName = isAddSearchHotelByName() && searchInput ? `&name=${searchInput}` : '';
    setIsCurrentListFromInputSearch(isAddSearchHotelByName());

    fetch(
      `${urlData.url}?page=${pageHotelToLoad}&size=${LIMIT_SIZE_PAGINATION}${inputSearchHotelName}`, options
      ).then(
      resp => {
        if (resp.ok) {
          resp.json().then(
            data => {
              let lastHotelLoated

              if(isFromDetail){
                setIsFromDetail(false)
                lastHotelLoated = saveLastLoadedHotel
              } else if (!isActionFromInputSearch){
                lastHotelLoated = hotelLoaded
              } else {
                lastHotelLoated = []
              }
              setSaveLastLoadedHotel(lastHotelLoated)

              setHotelLoaded([
                ...lastHotelLoated,
                ...data.content ?? []
              ]);
              setDiplayLoadMoreBtn(!data.last);
              setLoader(false);
              setSearchInputLoading(false);
              setIsActionFromInputSearch(false);
              setIsCurrentListFromFilter(false);
              setDiplayLoaderToLoadMoreBtn(false);
            }
          )
        } else {
          setDiplayLoaderToLoadMoreBtn(false);
        }
      }
    )
  }


  const modalError = (title, message) => {
    Modal.error({
      title: title,
      content: message,
      onOk() {
        return;
      }
    });
  };

  const linkClicked = () => {
    setScrollPosition(window.scrollY)
  };

  if (error){
    modalError(TITRE_LISTE_HOTEL, 'Ooups ! Une erreur est survenue');
    return ; 
  }
  if (data && (data.length== 0 || loading)) { 
    return <Loader />;
  }

  let filtre = {} ; 
  data.map(
    ({
      key,
      value
    }) => {
      switch (key) {
        case getUrlArray()[0].url:
          filtre.equipement = value.sort((a, b) => a.description > b.description ? 1 : -1);
          break;
        case getUrlArray()[1].url:
          filtre.propriete = value.sort((a, b) => a.libelle > b.libelle ? 1 : -1);
          break;
        default:
          break;
      }

    })

  
  return (
    <ListingWrapper>
      <Row>
        <Col sm={4}>
          {
            width > 991 ? (
              <CategorySearch 
                defaultParamHotel ={defaultParamHotel} 
                filtre={filtre} setTitle={setTitle}
                setparamFiltre={setparamFiltre}
                setLoader={setLoader} 
                setHotelLoaded={setHotelLoaded} 
                page={0} 
                size= {LIMIT_SIZE_PAGINATION}
                setDiplayLoadMoreBtn={setDiplayLoadMoreBtn}
                setIsCurrentListFromFilter={setIsCurrentListFromFilter}
                setIsOffreChecked={setIsOffreChecked}
                isOffreChecked={isOffreChecked}
              />
            ) : (
              <FilterDrawer 
                defaultParamHotel={defaultParamHotel} 
                filtre={filtre} 
                setTitle={setTitle} 
                setLoader={setLoader} 
                setHotelLoaded={setHotelLoaded} 
                page={0} 
                size= {LIMIT_SIZE_PAGINATION}
                setDiplayLoadMoreBtn={setDiplayLoadMoreBtn}
                setparamFiltre={setparamFiltre}
                setIsCurrentListFromFilter={setIsCurrentListFromFilter}
                setIsOffreChecked={setIsOffreChecked}
                isOffreChecked={isOffreChecked}
              />
            )
          }
        </Col>
        <Col sm={20}>
          {
          loader ? <Loader/>
            : 
            <div>
              <ListingGrid 
                title={title} 
                currency={currency} 
                data={hotelLoaded} 
                listHotel={listHotel}
                diplayLoadMoreBtn={diplayLoadMoreBtn}
                loadMoreChambre={handleLoadMoreHotel}
                setSearchInput={setSearchInput}
                searchInputLoading={searchInputLoading}
                diplayLoaderToLoadMoreBtn={diplayLoaderToLoadMoreBtn}
                linkClicked={linkClicked}
              />
            </div>
            
           }
        </Col>
      </Row>
    </ListingWrapper>
  );
}
